import React from 'react';

export const DefaultInfos = ({ children }: { children: React.ReactNode }) => {
  return (
    <div className="mt-2 bg-gray-200 rounded-2xl text-gray-700 text-2xl text-light text-left mb-2 p-12">
      {children}
    </div>
  );
};
